// extracted by mini-css-extract-plugin
module.exports = {"container":"KfList_container__1l-86","empty":"KfList_empty__1HIiW"};